import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import {
  usePersonalizationBoards,
  getErrorMessage,
} from "../hooks/usePersonalizationQueries";

interface BoardSelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
}

export const BoardSelector: React.FC<BoardSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  error,
}) => {
  const {
    data: boards = [],
    isLoading,
    isError,
    error: queryError,
  } = usePersonalizationBoards();

  const hasError = isError || Boolean(error);
  const errorMessage = error || (isError ? getErrorMessage(queryError) : null);

  return (
    <div className="space-y-2">
      <Select
        value={value}
        onValueChange={onChange}
        disabled={disabled || isLoading}
      >
        <SelectTrigger
          className={`input-auth relative flex items-center justify-between ${
            hasError ? "border-red-300 focus:ring-red-300" : ""
          }`}
        >
          <SelectValue
            placeholder={
              isLoading
                ? "Loading boards..."
                : isError
                  ? "Failed to load boards"
                  : "Board"
            }
            className="text-white/60"
          />
        </SelectTrigger>

        <SelectContent className="bg-white/95 backdrop-blur-sm border border-white/30 rounded-[6px]">
          {boards.map((board) => (
            <SelectItem
              key={board.id}
              value={board.id}
              className="cursor-pointer font-inter text-[17px] font-normal leading-[22px] tracking-normal text-white"
            >
              {board.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {errorMessage && <p className="text-red-200 text-sm">{errorMessage}</p>}
    </div>
  );
};
